import { useEffect } from 'react';
import { Modal, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useMapContext } from '@/contexts/MapContext';
import { LoadingAnimation } from '../loader/LoadingAnimation';
import styles from './modal.module.css';

export const OptimalModeLoading = () => {
  const { setIsOptimalModeLoaded } = useMapContext();
  const [opened, { close }] = useDisclosure(true);

  useEffect(() => {
    setTimeout(() => {
      setIsOptimalModeLoaded(true);
      close();
    }, 3000);
  });

  return (
    <Modal
      classNames={{ content: styles['modal-content'] }}
      opened={opened}
      onClose={close}
      withCloseButton={false}
      closeOnEscape={false}
      closeOnClickOutside={false}
      centered
    >
      <div className={styles['modal-body']}>
        <LoadingAnimation />
        <Text size="md">Finding the optimal locations...</Text>
      </div>
    </Modal>
  );
};
